module.exports = __webpack_public_path__ + "static/media/quote.046cb327.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/quotes/quote.svg
// module id = 622
// module chunks = 0